import { Fields } from "../types/SchemaFactory";
import { TFunction } from "i18next";
import { schemaFactory } from "./SchemaFactory";
import { PhoneInfoForm } from "../domain/models/dto/PhoneDTO";

export const phoneInfoFields: Fields<PhoneInfoForm> = {
    phone: {
        min: 8,
        max: 13,
        required: false,
        placeholderKey: "phoneInfo.fields.phoneField",
        type: "text",
        initial: "",
    },
    viber: {
        min: 0,
        max: 1,
        required: true,
        placeholderKey: "phoneInfo.fields.viberField",
        type: "boolean",
        initial: false,
    },
    whatsapp: {
        min: 0,
        max: 1,
        required: true,
        placeholderKey: "phoneInfo.fields.whatsappField",
        type: "boolean",
        initial: false,
    },
};

export const phoneInfoSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, phoneInfoFields);
};
